import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'create',
    title: 'Thrivable - Create Account',
    loadChildren: () =>
      import('./pages/create-sso-account/create-sso-account-page.module').then(
        module => module.CreateSsoAccountPageModule
      ),
  },
  {
    path: 'create/:tokenId',
    title: 'Thrivable - Create Account',
    loadChildren: () =>
      import('./pages/create-account/create-account-page.module').then(
        module => module.CreateAccountPageModule
      ),
  },
  {
    path: 'unsubscribe',
    loadChildren: () =>
      import('./pages/unsubscribe-page/unsubscribe-page.module').then(
        module => module.UnsubscribePageModule
      ),
    title: 'Thrivable - Unsubscribe',
  },
  {
    path: 'create/company/:tokenId',
    title: 'Thrivable Company - Create Account',
    loadChildren: () =>
      import('./pages/create-account-company/create-account-company-page.module').then(
        module => module.CreateAccountCompanyPageModule
      ),
  },
  {
    path: 'migrate/:tokenId',
    title: 'Thrivable - Migrate Account',
    loadChildren: () =>
      import('./pages/migrate-user/migrate-user-page.module').then(
        module => module.MigrateUserPageModule
      ),
  },
  {
    path: 'reset/:tokenId',
    loadChildren: () =>
      import('./pages/reset-password/reset-password-page-user.module').then(
        module => module.ResetPasswordPageModule
      ),
    title: 'Thrivable - Reset Password',
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/initial-pages.module').then(module => module.InitialPagesModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
